import Entitlements from "services/Entitlements";
import { FEEDBACK_URL, ABBA_CONFIGS, PROMOTION_TYPES } from "common/constants/Constants";
import appConfig from "utils/appConfig";
import Redirect from "utils/Redirect";
import { getNumberOfPeriodsInMonth } from "common/utils/subscriptionCopyHelpers";

export const SAVE_OFFER_SET_SELECTED_OFFER = "SAVE_OFFER_SET_SELECTED_OFFER";
export const SAVE_OFFER_SET_OFFERS = "SAVE_OFFER_SET_OFFERS";
export const SAVE_OFFER_SET_LOADING = "SAVE_OFFER_SET_LOADING";
export const SAVE_OFFER_SET_PROCESSING = "SAVE_OFFER_SET_PROCESSING";

export const SAVE_OFFER_DO_NOT_HANDLE_ERROR = "SAVE_OFFER_DO_NOT_HANDLE_ERROR";

const DEFAULT_STATE = {
    selectedOffer: 0,
    allOffers: [],
    loading: false,
    processing: false
};

export function saveOfferReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case SAVE_OFFER_SET_SELECTED_OFFER:
            return {
                ...state,
                selectedOffer: action.selectedOffer
            };
        case SAVE_OFFER_SET_OFFERS:
            return {
                ...state,
                allOffers: action.allOffers
            };
        case SAVE_OFFER_SET_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case SAVE_OFFER_SET_PROCESSING:
            return {
                ...state,
                processing: action.processing
            };
        default:
            return state;
    }
}

export function setSelectedOffer(selectedOffer) {
    return {
        type: SAVE_OFFER_SET_SELECTED_OFFER,
        selectedOffer
    };
}

export function setOffers(offers) {
    return {
        type: SAVE_OFFER_SET_OFFERS,
        allOffers: offers
    };
}

export function setSaveOfferIsLoading(isLoading) {
    return {
        type: SAVE_OFFER_SET_LOADING,
        loading: isLoading
    };
}

export function setSaveOfferIsProcessing(isProcessing) {
    return {
        type: SAVE_OFFER_SET_PROCESSING,
        processing: isProcessing
    };
}

export function fetchRatePlanInformation(productType, promotionType, renewalPrice, billingPeriod) {
    return (dispatch, getState) => {
        const {
            abba: {
                config: {
                    [ABBA_CONFIGS.SAVE_OFFERS]: {
                        ratePlanIds,
                        showSaveOffers
                    } = {
                        ratePlanIds: "",
                        showSaveOffers: false
                    }
                }
            }
        } = getState();

        if (promotionType === PROMOTION_TYPES.SAVE_OFFER || !showSaveOffers) {
            Redirect.redirectTo(FEEDBACK_URL);
        }

        // appConfig().saveOffers will be used when we roll this out to 100%
        return Promise.all((ratePlanIds ? ratePlanIds.split(",") : appConfig().saveOffers).map(
            (ratePlanId) => Entitlements.getProductRatePlanInformation(ratePlanId)
        ))
            .then((values) => values
                .map(({ ratePlan }) => ratePlan)
                .filter((ratePlan) =>
                    ratePlan.productType === productType
                    && isBetterOffer(ratePlan.pricing, renewalPrice, billingPeriod)))
            .then((offers) => {
                if (offers.length) {
                    dispatch(setOffers(offers));
                    
                    return;
                }

                throw new Error("No available save offers");
            })
            .catch(() => {
                Redirect.redirectTo(FEEDBACK_URL);

                throw new Error(SAVE_OFFER_DO_NOT_HANDLE_ERROR);
            });
    };
}

function isBetterOffer(newPricing, oldRenewalPrice, oldBillingPeriod) {
    const newMonthlyPrice = parseFloat(newPricing.totalWithDiscount) / getNumberOfPeriodsInMonth(newPricing.billingPeriod);
    const oldMonthlyPrice = parseFloat(oldRenewalPrice) / getNumberOfPeriodsInMonth(oldBillingPeriod);

    return newMonthlyPrice < oldMonthlyPrice;
}

export default {
    fetchRatePlanInformation,
    setSelectedOffer,
    setOffers,
    setSaveOfferIsLoading,
    setSaveOfferIsProcessing
};
